<template>
  <button
    v-if="showButton"
    :disabled="disabled && !validateOnNext"
    @click.prevent="onNext"
    :class="{
      [$style.buttonNext]: true,
      [$style.buttonNextNewDesign]: isNewDesign,
      [$style.btnAnimation]: !disabled,
      [$style.btnLong]: longButton,
      [$style.btnLongNewDesign]: longButton && isNewDesign,
      [$style.marginLeftMedium]: slide.paddingLeft === 'medium',
      [$style.validateOnNext]: validateOnNext,
      [$style.disabledView]: validateOnNext && disabled,
      [$style.disabledViewNewDesign]: validateOnNext && disabled && isNewDesign,
      [$style.btnLink]: btnLink,
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone,
      [$style.small]: el.is.small
    }"
  >
    <template v-if="!btnLink">
      <span :class="$style.text">{{ getText }}</span>
      <img :class="$style.icon" :src="getImg" alt="next arrow" />
    </template>
    <template v-else>
      <span :class="$style.linkText">{{ getText }}</span>
    </template>
  </button>
</template>

<script>
import store from '@/store'
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      timeout: null
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    formNames() {
      return store.state.formNames
    },
    hiddenInputs() {
      return store.state.hiddenInputs
    },
    salesforce() {
      return store.state.salesforce
    },
    el() {
      return store.state.el
    },
    text() {
      return store.getters['nextButtonText']
    },
    imgName() {
      return store.getters['nextButtonImg']
    },
    btnLink() {
      return store.getters['nextButtonLink']
    },
    slide() {
      return store.getters['slide']
    },
    validateOnNext() {
      return store.getters['validateOnNext']
    },
    getImg() {
      if (this.imgName) {
        if (this.isNewDesign) {
          // note: new design
          return require('../../assets/images/icon_next_new.svg')
        } else {
          return require('../../assets/images/' + this.imgName + '.svg')
        }
      } else {
        if (this.isNewDesign) {
          // note: new design
          return require('../../assets/images/icon_next_new.svg')
        } else {
          return require('../../assets/images/icon-next.svg')
        }
      }
    },
    getText() {
      return this.text ? this.text : 'weiter'
    },
    disabled() {
      return !store.getters['nextEnabled']
    },
    showButton() {
      return store.getters['showNextButton']
    },
    longButton() {
      return store.getters['nextButtonLong']
    }
  },
  methods: {
    sendData() {
      const data = []
      // add combined street and houseNumber
      let slide19address = ''
      let slide21address = ''

      // duplicate address fields
      let city = ''
      let postalCode = ''
      let state = ''

      this.salesforce.forEach(sf => {
        if (sf.name === this.formNames.FORM_19_1_1.name) {
          slide19address = sf.value + ' '
        }
        if (sf.name === this.formNames.FORM_19_1_2.name) {
          slide19address += sf.value
        }
        if (sf.name === this.formNames.FORM_21_8_1.name) {
          slide21address = sf.value + ' '
        }
        if (sf.name === this.formNames.FORM_21_8_2.name) {
          slide21address += sf.value
        }

        if (sf.name === this.formNames.FORM_19_2.name) {
          postalCode = sf.value
        }
        if (sf.name === this.formNames.FORM_19_3.name) {
          city = sf.value
        }
        if (sf.name === this.formNames.FORM_19_4.name) {
          state = sf.value
        }
      })
      this.salesforce.forEach(sf => {
        if (sf.name === this.formNames.FORM_19_1.name) {
          sf.value = slide19address
        }
        if (sf.name === this.formNames.FORM_21_8.name) {
          sf.value = slide21address
        }
      })

      // reformat data
      this.salesforce.forEach(sf => {
        if (sf.value || sf.mandatory) {
          data.push({ [sf.name]: sf.value })
        }
      })

      // add cookie values
      const bing = Cookies.get('bing') || ''
      const facebook = Cookies.get('facebook') || ''
      const faOrderID = Cookies.get('faOrderID') || ''
      const google = Cookies.get('google') || ''
      const utmpara = Cookies.get('utmpara') || ''
      data.push({ '00N3V000000sTMY': utmpara })
      data.push({ '00N3V000000sV0o': facebook })
      data.push({ '00N3V000000wjXn': google })
      data.push({ '00N3V000000sV0j': bing })
      data.push({ '00N3V000000sZGM': faOrderID })

      // duplicate address fields
      data.push({ '00N9Y000000OvkR': city })
      data.push({ '00N9Y000000OvkW': postalCode })
      data.push({ '00N9Y000000Ovkb': state })

      // new values added from ticket #147
      data.push({ '00N9Y000000OQ0T': 'Website' })
      data.push({ '00N9Y000000OQ0Y': 'Angebot' })

      console.log(data);

      let sendingData = ''
      data.forEach(d => {
        const URLparams = new URLSearchParams(Object.entries(d))
        sendingData += '&' + URLparams.toString()
      })
      sendingData = sendingData.substring(1)

      // 1: SALESFORCE
      axios({
        method: 'post',
        url:
          'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
        data: sendingData
      })
        .then(res => {
          // console.log('response', res)
        })
        .catch(err => {
          // console.log(err)
        })

      // 2: MARKETING
      let anrede = ''
      let vorname = ''
      let nachname = ''
      let email = ''
      let postleitzahl = ''

      this.slide.forms.forEach(form => {
        form.inputs.forEach(input => {
          if (input.formName.name === this.formNames.FORM_21_1.name) {
            anrede = input.selectedValue === 'Herr' ? 1 : 2
          }
          if (input.formName.name === this.formNames.FORM_21_3.name) {
            vorname = input.selectedValue
          }
          if (input.formName.name === this.formNames.FORM_21_4.name) {
            nachname = input.selectedValue
          }
          if (input.formName.name === this.formNames.FORM_21_5.name) {
            email = input.selectedValue
          }
          if (input.formName.name === this.formNames.FORM_21_9.name) {
            postleitzahl = input.selectedValue
          }
        })
      })

      // note: dtk -> without postleitzahl
      if (!this.isNewDesign) {
        axios.post(
          'https://link.mail.deutscheteilkauf.de/u/register.php?CID=760771904&f=494&p=2&a=r&SID=&el=&llid=&counted=&c=',
          null,
          {
            params: {
              inp_46: anrede,
              inp_1: vorname,
              inp_2: nachname,
              inp_3: email
            }
          }
        )
      }
      // note: hausanker with postelizahl
      else {
        axios.post(
          'https://link.mail.deutscheteilkauf.de/u/register.php?CID=760771904&f=890&p=2&a=r&SID=&el=&llid=&counted=&c=',
          null,
          {
            params: {
              inp_46: anrede,
              inp_1: vorname,
              inp_2: nachname,
              inp_3: email,
              inp_13: postleitzahl
            }
          }
        )
      }
    },
    onNext() {
      // return if button has validate prop (not button:disabled, so we have to fake it)
      // trigger inputs, selects and checkboxes validation
      if (this.validateOnNext && this.disabled) {
        store.dispatch('toggleValidateInputs')
        this.timeout = setTimeout(() => {
          store.dispatch('toggleValidateInputs')
        }, 3000)
        return
      }

      if (store.getters['sendData']) {
        this.$emit('checkProps')
        // check honeypot input (bot)
        let honeypotInputEmpty = true
        this.salesforce.forEach(sf => {
          if (sf.name === this.hiddenInputs.INPUT_14.name) {
            if (sf.value) {
              honeypotInputEmpty = false
            }
          }
        })
        if (honeypotInputEmpty) {
          this.sendData()
        }
      }
      // LINK BUTTON
      if (this.btnLink) {
        location.href = this.btnLink
      }
      // REGULAR BUTTON
      else {
        this.$emit('next')
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  }
}
</script>

<style lang="scss" module>
@import '@/scss/animations.scss';
@import '@/scss/variables.scss';

.buttonNext {
  user-select: none;
  cursor: pointer;
  display: flex;
  width: 240px;
  height: 100%;
  justify-content: space-evenly;
  align-items: center;
  border: none;
  outline: none;
  color: $color_bg_light;
  background-color: $color_green_2;
  font-size: 22px;
  margin-left: auto;

  .icon {
    height: 20.93px;
    width: 32.7px;
    border: none;
  }

  .text {
    display: inline-block;
    padding: 15px;
  }
}

// note: new design
.buttonNextNewDesign {
  background: $color_progress_new;
  box-shadow: 0px 1px 4px rgba(38, 40, 37, 0.16),
    0px 6px 12px rgba(38, 40, 37, 0.04);
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 1px;

  .icon {
    height: 36px;
    width: 36px;
  }
}

.buttonNext:disabled {
  cursor: not-allowed;
  background-color: $color_grey_1;
}

.buttonNextNewDesign:disabled {
  background: #ece8e5;
  border: 2px solid #cecece;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgba(38, 40, 37, 0.16),
    0px 6px 12px rgba(38, 40, 37, 0.04);
  border-radius: 6px;
}

.validateOnNext:disabled {
  cursor: pointer;
}

.disabledView {
  background-color: $color_grey_1 !important;
}

.disabledViewNewDesign {
  background: #ece8e5 !important;
  border: 2px solid #cecece;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgba(38, 40, 37, 0.16),
    0px 6px 12px rgba(38, 40, 37, 0.04);
  border-radius: 6px;
}

// prop
.btnLong {
  width: 493px;
  background-color: $color_green_2;

  .icon {
    height: 24px;
    width: 26px;
    border: none;
  }
}

// note: new design
.btnLongNewDesign {
  text-align: left;
  padding-right: 15px;
  background-color: $color_progress_new;
  .icon {
    height: 36px;
    width: 36px;
  }
  .text {
    text-align: center;
    padding: 0;
    padding-left: 10px;
  }
}

// note: new design
.btnLongNewDesign:disabled {
  background: #ece8e5;
  border: 2px solid #cecece;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgba(38, 40, 37, 0.16),
    0px 6px 12px rgba(38, 40, 37, 0.04);
  border-radius: 6px;
}

// prop - link button
.btnLink {
  width: auto;
  padding: 25px;
  align-items: center;
}

// prop
.marginLeftMedium {
  margin-left: 200px;
}

// note: LAND
.land {
  &.btnLong {
    width: 423px;
  }
  &.marginLeftMedium {
    margin-left: 60px;
  }
}

// note: PORT
.port {
  &.marginLeftMedium {
    margin-left: 50px;
  }
}

// note: PHONE
.phone {
  &.btnLong {
    width: 250px;
    padding-left: 0px;
  }
  &.marginLeftMedium {
    margin: 0 auto;
  }

  // note: new design
  &.buttonNextNewDesign {
    width: auto;
    // .text {
    //   font-size: 15px;
    // }
  }

  // note: new design
  &.btnLongNewDesign {
    .text {
      font-size: 15px;
    }
  }
}

// note: small phone
.small {
  .linkText {
    font-size: 14px;
  }
}
</style>
